import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Course, CourseList, IPCourseLIst} from './interface/course.interface';
import { AlertService } from './services/alert.service';
import { CrudService } from './services/crud.service';
import { ReflectionService } from './utilities/reflection.service';

@Injectable()
export class CourseService extends CrudService<Course> {
    constructor(protected http: HttpClient, private reflection: ReflectionService, private alert: AlertService) {
        super(http, 'course');
    }

    currentCourse: Course;
    currentTerm: string;
    section: string;

    get(termCode: string, netId: string = '', section: string = ''): Observable<CourseList> {
        this.currentTerm = termCode;
        if (this.reflection.isNotNullOrEmpty(section)) {
            this.section = section;
            return this.http.get<CourseList>(`/api/course/term/${termCode}/netid/${netId}?section=${section}`);
        }
        return this.http.get<CourseList>(`/api/course/term/${termCode}/netid/${netId}`);
    }

    getByCRN(termCode: string, crn: string): Observable<CourseList> {
        this.currentTerm = termCode;
        return this.http.get<CourseList>('/api/course/term/' + termCode + '/crn/' + crn, {});
    }

    getByTermAndCRN(termCode: string, crn: string): Observable<Course> {
        this.currentTerm = termCode;
        return this.http.get<Course>('/api/course/' + termCode + '/' + crn, {});
    }

    setCurrentCourse(course: Course) {
        this.currentCourse = course;
    }

    getCurrentCourse() {
        return this.currentCourse;
    }

    sendEmail(obj: any): Observable<any> {
        return this.http.post<any>(`/api/course/sendEmail`, obj);
    }



    setCurrentSection(section: string) {
        this.section = section;
    }
}
